@if (copy.length > 0){

    @switch (size) {
        
      @case ('small') {
        <p
          [ngClass]="class"
          class="text-sm/5 text-surface-600 font-semibold dark:text-surface-400 tracking-[0.006em]"
          [innerHTML]="copy"></p>
      }
      @case ('medium') {
        <p
          [ngClass]="class"
          class="text-base/6 text-surface-600 font-semibold dark:text-surface-400 tracking-[0.009em]"
          [innerHTML]="copy"></p>
      }
      @case ('large') {
        <p
          [ngClass]="class"
          class="text-[1.375rem]/7 text-surface-600 font-semibold dark:text-surface-400 tracking-normal"
          [innerHTML]="copy"></p>
        }
    }

}
